import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Inject,
  Output,
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormArray,
  UntypedFormControl
} from '@angular/forms';
import { finalize, first, map, switchMap } from 'rxjs/operators';
import { ToasterService } from '../../../../services/core/toaster.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotOnlySpaces } from '../../../shared/CustomValidators/CustomNotOnlySpacesValidator';
import { ProposalDataService } from '../proposal.data.service';
import { forkJoin } from 'rxjs';
import { BidDataService } from '../../bid/bid.data.service';
import { CreateEditBidComponent } from '../../bid/create-edit-bid/create-edit-bid.component';
import { DialogService } from '../../../../services/core/dialog.service';
import { JsonService } from 'src/app/services/core/json.service';

@Component({
    selector: 'app-create-proposal',
    templateUrl: './create-proposal.component.html',
    styleUrls: ['./create-proposal.component.scss'],
    standalone: false
})
export class CreateProposalComponent implements OnInit {
  public submitted = false;
  proposalForm: UntypedFormGroup;
  copyProposalForm: UntypedFormGroup ;
  bids: any = [];
  offices: any = [];
  customer_id: any = '';
  bid_id: any = '';
  customer_default_contact_id: any = '';
  proposalOrigin = '';
  copyScope = false;
  default_copy_proposal_id: any
  public tenantProps: any = {};
  defaultCopyProposalData: any = '';
  @Output() callback = new EventEmitter<any>(true);

  bidDetail: any = null;
  processCopyRequestInProgress = false;

  selectedProposal: any = '';
  customers: any = '';
  contacts: any = '';
  proposalID: any = '';
  scopeSelections: any = [];
  public cloneScopes: any= [];
  proposalSearchAbleParams: any =  {
    page: 1,
    per_page: 200,
    sort_by: 'id',
    sort_order: 'desc',
    // search: '',
    columns: [],
  };
  public userDetail:any = null;
  public bid: any;

  constructor(
    public fb: UntypedFormBuilder,
    public bidDataService: BidDataService,
    public toasterService: ToasterService,
    public dialogService: DialogService,
    public proposalDataService: ProposalDataService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreateProposalComponent>,
    public jsonService: JsonService
  ) {
    this.copyProposalForm = this.initCopyProposalForm();
    this.customer_id = this.data?.customer_id;
    this.bid_id = this.data?.bid_id;
    this.bids = this.data?.bids;
    this.customer_default_contact_id = this.data?.customer_default_contact_id;
    this.proposalOrigin = this.data.proposalOrigin || '';
    this.copyScope = this.data?.copyScope;
    this.default_copy_proposal_id = this.data?.default_copy_proposal_id;
    this.bid = data?.bid;
    this.proposalForm = this.generateForm();

    if (this.customer_id) {
      this.proposalForm.get('customer_id')?.setValue(this.customer_id);
      console.log(this.proposalForm.get('customer_id')?.value, "cus")
    }
  }

  ngOnInit(): void {
    if (!this.data?.bids) { // this if condition, currently it is useless condition
      this.getData();
    }

    if (this.bid_id) {
      this.getBidDetails(this.bid_id)
      .subscribe((response: any) => {
        this.onCopyBidValueChange(response);
      });
    }

    this.userDetail = this.jsonService.doParse(localStorage.getItem("auth_detail"))
    this.proposalForm.get('tenant_id')?.setValue(this.userDetail.current_tenent.id);
    if(this.default_copy_proposal_id){
      this.getProposalData();
    }

    this.setOfficeList()
  }

  setOfficeList() {
    this.offices = []
    // if(this.copyScope) {
      // this.userDetail = this.jsonService.doParse(localStorage.getItem("auth_detail"))
    // this.copyProposalForm.get('tenant_id')?.setValue(this.userDetail.current_tenent.id);

    let ids = this.userDetail.attach_tenents?.map((tenant: any) => tenant?.id)
    this.bid?.tenants.forEach((element: any) => {
     if(ids.includes(element.id)) {
       this.offices.push(element)
       if(ids.includes(this.userDetail.current_tenent.id)) {
        this.copyProposalForm.get('tenant_id')?.setValue(this.userDetail.current_tenent.id);

        this.customersFormArray().clear();
        this.customers = this.bid.customers.filter((customer:any) => customer.tenant.id === this.userDetail.current_tenent.id) || [];
        this.customers?.map((value: any) => {
          this.addCustomer(value);
        });
       }
     }
   });
    if(this.offices.length == 1) {
      this.copyProposalForm.get('tenant_id')?.setValue(this.offices[0].id);

      this.customersFormArray().clear();
        this.customers = this.bid.customers.filter((customer:any) => customer.tenant.id === this.offices[0].id) || [];
        this.customers?.map((value: any) => {
          this.addCustomer(value);
        });

    }
    // }
  }
  getProposalDetail(id: any){
    this.proposalDataService.create(id)
      .pipe(first())
      .subscribe(
        response => {
          response?.data.data;
        });
  }

  getBidDetails(bidId: any, param:any={}) {
    return this.bidDataService.detail(bidId, param).pipe(
      first(),
      map((data) => {
        this.bid = this.bidDetail = data.data;
        // this.setOfficeList()

        // Once the inner API call completes successfully, return this.bidDetail
        return this.bidDetail;
      })
    );
    // .pipe(first())
    // .subscribe(
    //   data => {
    //     this.bidDetail = data.data;
    //   });
  }

  getData() {
    // const params = {
    //   page: 1,
    //   per_page: 5,
    //   sort_by: 'bid_number',
    //   sort_order: 'desc',
    //   //search: this.searchTerm,
    //   columns: [],
    // }

    // this.bidDataService.list(params).subscribe((response: any) => {
    //   this.bids = response.data;

    if (this.bid_id) {
      this.proposalForm.get('bid_id')?.setValue(this.bid_id);
      this.copyProposalForm.get('bid_id')?.setValue(this.bid_id);

    }
    // })
  }
  getProposalData = () => {
    this.proposalDataService.detail(this.default_copy_proposal_id)
      .pipe(first())
      .subscribe(
        data => {
          const proposalData = data?.data;
          proposalData.proposal_total = proposalData?.total;
          this.defaultCopyProposalData = proposalData;
          this.onItemSelect(proposalData,true);
        },
        error => {

        }
      );
  }
  selectedValueChange(event: any) {
    this.offices = []
   let ids = this.userDetail.attach_tenents?.map((tenant: any) => tenant?.id)

   event.tenants.forEach((element: any) => {
    if(ids.includes(element.id)) {
      this.offices.push(element)
    }
  });

    this.proposalForm.get('bid_id')?.setValue(event ? event.id : null);
    this.onCompanyChangeProposalCreate({id:this.proposalForm.get('tenant_id')?.value})
  }

  touchFormControls(){
    Object.keys(this.proposalForm.controls).forEach(key => {
      this.proposalForm.get(key)?.markAsTouched();
    });
  }
  onSubmit() {
    this.touchFormControls();
    if (this.proposalForm.invalid) {
      return;
    };




    // this.getBidDetails(this.proposalForm?.get('bid_id')?.value).subscribe(bid => {
      // const bid = this.bids.find((x:any) => x.id == this.proposalForm?.get('bid_id')?.value);

      if (this.customer_id && this.customer_default_contact_id){

        const customerT = this.customers.find((x:any) => x.id == this.customer_id);
        // console.log('customerT', customerT)
        if (!customerT){
          this.attachCustomerAsBidder();
        }else {
          this.preCloseModel();
        }


      }else {
        // if(bid.customers.length == 0){
        //   this.toasterService.showWarning('Can not create proposal as no bidder is added to the selected bid.');
        //   return;
        // }
        this.preCloseModel();
      }

      // })






    // this.proposalDataService.create(this.proposalForm.value)
    //   .pipe(first())
    //   .subscribe(
    //     response => {
    //       this.proposalForm.reset();
    //       this.close(response);
    //       this.toasterService.showSuccessMessage(response?.data.message);
    //     });
  }
  preCloseModel(){
    this.getBidDetails(this.proposalForm?.get('bid_id')?.value, { tenant_id: this.proposalForm.get('tenant_id')?.value }).subscribe(bid => {
      const customerT = bid.customers.find((x:any) => x.id == this.proposalForm.get('customer_id')?.value);
      const data = {
        // bid: this.bids.find((x:any) => x.id == this.proposalForm?.get('bid_id')?.value)
        bid : bid,
        proposalOrigin : this.proposalOrigin,
        tenant_id: this.proposalForm.get('tenant_id')?.value,
        customer_id: this.proposalForm.get('customer_id')?.value,
        contact_id: customerT.contact.id


      };
      this.close(data);

    });

  }
  attachCustomerAsBidder() {
    const data = {
      id: this.proposalForm?.get('bid_id')?.value,
      customer_id: this.customer_id,
      contact_id: this.customer_default_contact_id,
      proposal_id: 0,
      is_create_duplicate_proposal: 0,
      tenant_id: this.proposalForm.get('tenant_id')?.value
    };

    const service =  this.bidDataService.addBidders(data?.id, data);

    service.pipe(first())
      .subscribe(
        data => {
          // this.proposalForm.get('customer_id')?.setValue(this.customer_id);
          this.toasterService.showSuccessMessage('Customer Added as bidder to the bid.');
          this.preCloseModel();
        });
  }

  createBid(): void {
    this.dialogService.onOpenDialog(CreateEditBidComponent,
      {
        defaultCustomerId: this.customer_id,
        defaultContactId: this.customer_default_contact_id,
      },
      900,
      '99vh'
      );
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if(result.data?.data?.id){
        // this.bids.push(result.data?.data);
        // this.bids = [...this.bids];
        this.getBidDetails(result.data?.data?.id).subscribe(bid => {
          this.proposalForm.get('bid_id')?.setValue(result.data?.data?.id);

          this.offices = []
          let ids = this.userDetail.attach_tenents?.map((tenant: any) => tenant?.id)

          result.data?.data?.tenants.forEach((element: any) => {
           if(ids.includes(element.id)) {
             this.offices.push(element)
           }
         });
           this.onCompanyChangeProposalCreate({id:this.proposalForm.get('tenant_id')?.value})
        });
      }
    });
  }

  generateForm = () => {
    const formGroup = this.fb.group({
      bid_id: [null, [Validators.required]],
      tenant_id: new UntypedFormControl('', [Validators.required, NotOnlySpaces()]),
      customer_id: new UntypedFormControl(this.customer_id, [Validators.required, NotOnlySpaces()]),
    });

    // Add dynamic validation for `customer_id`
    if (this.customer_id) {
      formGroup.get('customer_id')?.clearValidators(); // Remove required validator
      formGroup.get('customer_id')?.setValue(this.customer_id);
    } else {
      formGroup.get('customer_id')?.setValidators([Validators.required, NotOnlySpaces()]); // Add required validator
    }

    formGroup.get('customer_id')?.updateValueAndValidity(); // Update the form control validity

    return formGroup;
  }








  //Copy Scope
  onCopyBidValueChange(event: any) {
    if(event){
      this.bid = event;
      this.customers = [];
      this.contacts = event.contacts;
      this.customersFormArray().clear();
      this.copyProposalForm.get('bid_id')?.setValue(event ? event.id : null);
      // this.customers?.map((value: any) => {
      //   this.addCustomer(value);
      // });
      this.setOfficeList()
    }
    else{
      this.customers = [];
      this.contacts = [];
      this.copyProposalForm.get('tenant_id')?.setValue(null);
      this.customersFormArray().clear();
    }


  }
  initCopyProposalForm = () => {
    return this.fb.group({
      scopes: new UntypedFormArray([]),
      customers: new UntypedFormArray([]),
      bid_id: [null, []],
      tenant_id:new UntypedFormControl('',[Validators.required,NotOnlySpaces()]),
    });
  }
  addScope(scope: any = null) {
    this.scopesFormArray().push(this.scopeFormObject(scope));
  }
  scopeFormObject(scope: any = null): UntypedFormGroup {
    return this.fb.group({
      id: [scope?.id],
      scope_name: [scope?.scope_name ],
      final_sale_quote: [scope?.final_sale_quote ],
      service_name: [scope?.service_name ],
      is_checked: [true],
    })
  }

  addCustomer(customer: any = null) {
    this.customersFormArray().push(this.customerFormObject(customer));
  }
  customerFormObject(customer: any = null): UntypedFormGroup {
    return this.fb.group({
      id: [customer?.id],
      is_checked: [true],
    })
  }

  scopesFormArray (): UntypedFormArray {
    return this.copyProposalForm?.get('scopes') as UntypedFormArray
  }
  customersFormArray(): UntypedFormArray {
    return this.copyProposalForm?.get('customers') as UntypedFormArray
  }

  close = (data: any = '') => {
    this.dialogRef.close(data);
  }



  onItemSelect(e: any,isAllDataAvailable: boolean = false){
    if(isAllDataAvailable){
      this.cloneScopes =  e?.relations?.scopes;
      this.scopesFormArray().clear();
      this.cloneScopes?.map((scope: any, index: number) => {
         this.addScope(scope);
       });
    }else{
      this.proposalDataService.detail(e?.id).subscribe((response: any) => {
        this.cloneScopes =  response?.data?.relations?.scopes;
        this.scopesFormArray().clear();
        this.cloneScopes?.map((scope: any, index: number) => {
         this.addScope(scope);
       });

    })

  }

    this.selectedProposal = e;

  }
  onChangeScopes(event: any, scope: any){
    console.log('e',event);
    const id = scope?.id;
    if (event.checked) {
      // If the checkbox is checked, add the ID to the selections array
      if (!this.scopeSelections.includes(id)) {
        this.scopeSelections.push(id);
      }
    } else {
      // If the checkbox is unchecked, remove the ID from the selections array
      const index = this.scopeSelections.indexOf(id);
      if (index !== -1) {
        this.scopeSelections.splice(index, 1);
      }
    }

  }
  processCopyProposal(){
    const { customerIds, scopeIds } = this.getCheckedCopyFormIds();
    const bid_id =  this.copyProposalForm.get('bid_id')?.value;


    if (!this.selectedProposal) {
      this.toasterService.showWarning('Please select a proposal.');
      return false;
    }
    if (!scopeIds.length) {
      this.toasterService.showWarning('Please select scopes.');
      return false;
    }
    if (!bid_id) {
      this.toasterService.showWarning('Please select a bid.');
      return false;
    }
    if (!customerIds.length) {
      this.toasterService.showWarning('Please select customers.');
      return false;
    }

    this.touchFormControls();
    if (this.copyProposalForm.invalid) {
      return;
    }

     const data = {
       scope_ids: scopeIds,
       customer_ids: customerIds,
       proposal_id: this.selectedProposal?.id,
       bid_id:bid_id,
       tenant_id: this.copyProposalForm.get('tenant_id')?.value

     }
      this.processCopyRequestInProgress = true;
    this.bidDataService.copyProposal(bid_id,data)
    .pipe(finalize(() => {
      this.processCopyRequestInProgress = false;
    }))
      .pipe(first())
      .subscribe(
        data => {
          console.log('data', data);
          this.toasterService.showSuccessMessage(data?.message);
          // this.proposalComponentsCommunicationService.setCopyScopes(this.scopeSelections);
          this.close();
        });
    return true;
  }
  getCheckedCopyFormIds(): { customerIds: number[], scopeIds: number[] } {
    const scopeIds = this.scopesFormArray()
      .controls // Access the array of controls
      .filter((control) => control.get('is_checked')?.value) // Filter checked items
      .map((control) => control.get('id')?.value); // Extract their IDs

    const customerIds = this.customersFormArray()
      .controls // Access the array of controls
      .filter((control) => control.get('is_checked')?.value) // Filter checked items
      .map((control) => control.get('id')?.value); // Extract their IDs

    return { customerIds, scopeIds };
  }
  onRemoveItemSelect(e: any){
    this.cloneScopes = [];
    this.selectedProposal = '';
    this.scopeSelections = [];
  }

  onCompanyChange(selectedValues: any) {
    this.customersFormArray().clear();

    this.getBidDetails(this.copyProposalForm.get('bid_id')?.value, { tenant_id: selectedValues.id }).subscribe(bid => {

      this.bidDetail = bid;
      this.customers = this.bidDetail.customers
      this.customers?.map((value: any) => {
        this.addCustomer(value);
      });
    });

    // this.customers = this.bid.customers.filter((customer:any) => customer.tenant.id === selectedValues.id) || [];

   }

   onCompanyChangeProposalCreate(selectedValues: any) {



    if (!this.customer_id) {
      this.proposalForm.get('customer_id')?.setValue(null);
    }

    this.getBidDetails(this.proposalForm?.get('bid_id')?.value, { tenant_id: selectedValues.id }).subscribe(bid => {

      this.bidDetail = bid;
      this.customers = this.bidDetail.customers
    });

   }

}
